/**
 * Convierte una plantilla de venta (productos plantilla) en líneas de la
 * cotización.
 *
 * Reglas:
 *   - cada producto de la plantilla entra como una línea independiente
 *   - la cantidad sale de la plantilla; si viene vacía o inválida se usa 1
 *   - el precio SIEMPRE sale del catálogo (la plantilla no fija precios)
 *   - la comisión y el descuento arrancan en 0 y el vendedor los edita después
 *   - cada línea lleva un `timestamp` propio porque la tabla ordena por él
 *
 * Sin imports de Vue/store: se verifica fuera del navegador con
 * `npm run test:plantilla-lines`.
 */
import { calcLineSubTotal, toAmount } from './lineTotals'

export const DEFAULT_UNIDADES = 1

export const buildPlantillaLines = (plantilla, { timestamp = Date.now() } = {}) => {
    if (!plantilla || !Array.isArray(plantilla.items)) return []

    return plantilla.items
        .filter((item) => item && item.id)
        .map((item, index) => {
            const cantidad = toAmount(item.quantity)
            const unidades = cantidad > 0 ? cantidad : DEFAULT_UNIDADES
            const price = toAmount(item.sale_unit_price)
            const { subTotal } = calcLineSubTotal({ price, comision: 0, unidades, descuentos: 0 })
            const nombre = item.name || item.description

            return {
                id: item.id,
                name: item.name,
                description: nombre,
                internal_id: item.internal_id,
                unit_type_id: item.unit_type_id,
                marca: item.marca,
                sale_unit_price: item.sale_unit_price,
                price,
                priceOrigen: item.sale_unit_price,
                comision: 0,
                descuentos: 0,
                unidades,
                idTipoMoneda: item.idTipoMoneda || (item.currency_type_id === 'USD' ? 2 : 1),
                rename: `${nombre} -|- ${item.internal_id}`,
                supplier_name: item.supplier_name || null,
                supplier_id: item.supplier_id || null,
                subTotal,
                timestamp: timestamp + index
            }
        })
}

/**
 * Agrega las líneas de una plantilla al final de la lista actual sin tocar las
 * líneas existentes.
 */
export const appendPlantillaLines = (lista, plantilla, options) => {
    const actuales = Array.isArray(lista) ? lista : []
    const nuevas = buildPlantillaLines(plantilla, options)

    return actuales.concat(nuevas)
}
